<template>
    <div class="header font-9">
        <div class="col">
            CV
        </div>
        <div class="col">
            Ad Revenue
        </div>
        <div class="col">
            Users
            <Tooltip class="users-tooltip"
                     :text="tooltipText"/>
        </div>
    </div>
</template>

<script>
import Tooltip from 'components/Tooltip/Tooltip.vue';

export default {
    name: 'CVWizardHeader',
    components: { Tooltip },
    data: () => ({
        tooltipText: 'Daily average number of users who generated ad revenue'
            + ' within the selected range, over the last 7 days'
    })
};
</script>

<style scoped lang="scss">
@import "~styles/styleGuide";

.header {
    display: grid;
    grid-template-columns: 80px 225px auto;
    color: $light-800;
    background-color: $white;
    line-height: 15px;
    border-top: 1px solid $light-200;
    border-bottom: 1px solid $light-200;

    @media #{$desktopAndAbove} {
        grid-template-columns: 80px 408px auto;
    }

    .col {
        padding-left: 32px;
        padding-top: 8px;
        padding-bottom: 8px;
    }
}

.users-tooltip {
    margin-left: 2px;
    vertical-align: middle;
    margin-top: -1px;
    display: inline-block;
}
</style>
